if ($('body').hasClass('page-template-recherche')) {

    if ($('#job').length) {
        $('#job').autocomplete({
            minLength: 2,
            source: function(request, response) {
                var results = $.ui.autocomplete.filter(functions, request.term);
                
                response(results);
            },
            select: function (event, ui) {
                $('#jobid').val(ui.item.id);
            },
            change: function(event, ui) {
                if(!ui.item) {
                    $("#job").val('');
                    $("#jobid").val('');
                }
            },
            response: function(event, ui) {
                if(!ui.content.length) {
                    ui.content.push({
                        value: '',
                        label: "Aucun métier trouvé dans la liste"
                    })
                }
            }
        })
    }
} 